// @flow
import React, { type Node } from 'react';

import { COLORS } from 'Components/utils/color/colors';

import { InputSwitch } from 'Components/frameworks/form-inputs/input-switch/InputSwitch.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

type Props = {
  index: number,
  isChecked: boolean,
  label: string,
  name: string,
  onChange: (index: number) => (name: string, checked: boolean) => void,
  title: string,
};

export const PreferencesItemSwitch = ({
  index,
  isChecked,
  label,
  name,
  onChange,
  title,
}: Props): Node => (
  <div className="flex mt-4">
    <div className="rtl:mr-4">
      <InputSwitch
        ariaDescribedby={`${name}-text`}
        ariaLabelledby={name}
        color={COLORS.EMERALD}
        isChecked={isChecked}
        isDisabled={index === 0}
        isSwitch
        name={name}
        onChange={onChange(index)}
        size="medium"
        value={name}
      />
    </div>
    <div className="flex-1">
      <h4
        id={name}
        className="reset-heading font-bold font-sans leading-normal text-gray-darker text-sm sm:text-base uppercase"
      >
        {title}
      </h4>
      <Text
        id={`${name}-text`}
        className="font-sans leading-normal text-gray-darker text-sm sm:text-base"
        text={label}
      />
    </div>
  </div>
);
